// Set responsive image sources for product grid items before lazy loading
(function() {
  'use strict';
  
  function setProductGridImageSrc(img) {
    if (!img || !img.nodeName || img.nodeName !== 'IMG') {
      return;
    }
    
    try {
      const isMobile = window.innerWidth && window.innerWidth <= 767;
      const mobileSrc = img.getAttribute('data-src-mobile');
      const desktopSrc = img.getAttribute('data-src-desktop');
      
      if (isMobile && mobileSrc) {
        img.setAttribute('data-src', mobileSrc);
      } else if (!isMobile && desktopSrc) {
        img.setAttribute('data-src', desktopSrc);
      } else if (mobileSrc) {
        // Fallback to mobile if desktop is missing
        img.setAttribute('data-src', mobileSrc);
      }
    } catch (e) {
      console.error('Error setting product grid image src:', e);
    }
  }
  
  function initProductGridImages() {
    try {
      const productImages = document.querySelectorAll('.sr-product-responsive-image');
      if (!productImages || productImages.length === 0) {
        return;
      }
      
      productImages.forEach(setProductGridImageSrc);
    } catch (e) {
      console.error('Error initializing product grid images:', e);
    }
  }
  
  // Initialize on DOM ready, before lazy loader processes images
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGridImages);
  } else {
    initProductGridImages();
  }
})();

